import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  header: {
    height: 60,
    width: 960,
    maxWidth: "100%",
    backgroundColor: "transparent",
    paddingLeft: "20px",
    paddingRight: "20px",
    position: "fixed",
    zIndex: 999,
  },
  wrapHeader: {
    display: "flex",
    padding: "15px 0",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    color: "#000",
    "@media (max-width: 480px)": {
        fontSize: 12,
        maxWidth: "150px",
      },
  },
  wrapIcon: {
    height: "100%",
    width: "20vh",
  },
  icCartBlack: {
    color: "#000",
  },
  icCart: {
    color: 'black',
    transition: '.2s ease-in'
}
}));

export default useStyles;
